import React from "react";
import { motion } from "framer-motion";

const RevealOnScroll = ({ children, delay = 0, y = 40, className = "", as: Tag = "div", ...rest }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default RevealOnScroll;
